<template>
    <div v-if="ready">
        <!-- S: PC -->
        <div v-if="!$vuetify.breakpoint.mobile">
            <v-data-table :items="expectations" :headers="expectationsHeaders" disable-sort hide-default-footer class="v-data-table--default">
                <v-rating slot="item.rating" slot-scope="{item}" :value="item.rating" color="yellow darken-1" background-color="grey" length="5" size="20" dense readonly />
                <template slot="item.writer" slot-scope="{item}">{{ item.writer.name }}</template>
                <template slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</template>
                <template slot="item.actions" slot-scope="{item}">
                    <div class="v-btn--group--x-small">
                        <v-btn  v-if="item._member == payload?._user" @click="edit(item)" x-small color="secondary">수정</v-btn>
                        <v-btn v-if="item._member == payload?._user" @click="remove(item)" x-small outlined color="grey"><span class="grey--text text--darken-3">삭제</span></v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>
        <!-- E: PC -->

        <!-- S: 모바일 -->
        <div v-else>
            <v-divider class="grey darken-4"/>
            <template v-for="expectation, index in expectations">
                <v-divider v-if="index" :key="`divider${expectation._id}`" class="grey lighten-1"/>
                <div :key="`title${expectation._id}`" class="pa-12px py-md-14px">
                    <v-row no-gutters align="center" class="font-size-14 font-size-md-16">
                        <v-col cols="auto">
                            <v-rating :value="expectation.rating" color="yellow darken-1" background-color="grey" length="5" size="16" dense readonly />
                        </v-col>
                        <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                        <v-col cols="auto">
                            <span>{{ $dayjs(expectation.createdAt).format("YYYY-MM-DD") }}</span>
                        </v-col>
                        <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                        <v-col cols="auto">
                            <span>{{ expectation.writer.name }}</span>
                        </v-col>
                    </v-row>
                </div>

                <div :key="`content${expectation._id}`" class="pa-12px py-md-14px grey lighten-4">
                    <span class="font-size-14 font-size-md-16">{{ expectation.content }}</span>
                    <div v-if="expectation._member == payload?._user" class="mt-10px">
                        <div class="v-btn--group--x-small">
                            <v-btn @click="edit(expectation)" x-small color="secondary">수정</v-btn>
                            <v-btn @click="remove(expectation)" x-small outlined class="white" style="border-color:#9e9e9e!important;"><span class="grey--text text--darken-3">삭제</span></v-btn>
                        </div>
                    </div>
                </div>
            </template>
            <v-divider class="grey lighten-1"/>
        </div>
        <!-- E: 모바일 -->

        <div class="mt-20px mt-md-30px">
            <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search" />
        </div>

        <div class="mt-20px mt-md-30px">
            <div class="pa-12px py-md-14px grey lighten-4">
                <v-row no-gutters align="center">
                    <v-col cols="auto">
                        <strong class="font-size-16 font-size-md-18 font-weight-medium">평점</strong>
                    </v-col>
                    <v-col cols="auto" class="d-flex"><v-divider vertical class="grey lighten-1 mx-8px" style="height:12px;" /></v-col>
                    <v-col cols="auto">
                        <v-rating v-model="expectation.rating" color="yellow darken-1" background-color="grey" length="5" dense size="20" />
                    </v-col>
                </v-row>
                <div class="mt-10px">
                    <v-row class="row--x-small">
                        <v-col>
                            <v-text-field v-model="expectation.content" placeholder="이 책의 기대평(한줄평)을 간단히 남겨주세요" outlined hide-details class="white" />
                        </v-col>
                        <v-col cols="auto">
                            <v-btn @click="save" color="primary" class="v-btn--input">기대평 등록</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>

        <v-dialog v-model="dialog" max-width="500">
            <v-card class="v-card--dialog v-card--dialog--sm">
                <div class="v-card--dialog__head">
                    <h3 class="tit tit--xs">기대평</h3>
                    <v-btn fab color="transparent" @click="dialog = false" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="v-card--dialog__body">
                    <div>
                        <v-textarea v-model="expectation.content" placeholder="기대평을 입력해주세요" persistent-placeholder outlined hide-details rows="8" />
                    </div>
                </div>
                <div class="v-card--dialog__foot">
                    <v-row class="row--x-small">
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn @click="save2" color="primary">등록</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-dialog>

        <login-dialog ref="loginDialog" />
    </div>
</template>
<script>
import api from "@/api";
import LoginDialog from "@/components/client/login/login-dialog.vue";
export default {
    components: {
        LoginDialog
    },
    props: {
        product: Object
    },
    data(){
        return {
            ready: false,

            page: 1,
            pageCount: 0,
            limit: 5,

            dialog: false,

            expectations: [],
            expectation: {},
            expectationsHeaders: [
                { text: "기대점수", value: "rating", align: "center", width: "16%" },
                { text: "기대평", value: "content", align: "center", width: "46%"  },
                { text: "작성자", value: "writer", align: "center", width: "14%" },
                { text: "작성일자", value: "createdAt", align: "center", width: "14%" },
                { text: "-", value: "actions", align: "center", width: "10%" },
            ],

            expectation: null,
        }
    },
    mounted(){
        this.search();
    },
    methods: {
        async search(){
            let { summary, expectations } = await api.v1.shop.products.expectations.gets(this.product._id, {
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            });
            this.expectations = expectations;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);

            this.expectation = {
                _product: this.product._id,
                content: null,
                rating: 5,
            }

            this.ready = true;
        },

        async login(){
            return new Promise((resolve, reject) => {
                if(this.logon) resolve();
                else{
                    this.$refs.loginDialog.$off();
                    this.$refs.loginDialog.$on("login", _ => resolve());
                    this.$refs.loginDialog.$on("cancel", _ => reject());
                    this.$refs.loginDialog.open();
                }
            });
        },

        edit(expectation){
            this.expectation = { ...expectation };
            this.dialog = true;
        },

        async save(){
            if(confirm("기대평을 등록하시겠습니까?")){
                this.login().then(async () => {
                    await api.v1.shop.products.expectations.post(this.product._id, this.expectation);
                    alert("기대평이 등록되었습니다");
                    this.search();
                });
            }
        },

        async save2(){
            if(confirm("기대평을 등록하시겠습니까?")){
                this.login().then(async () => {
                    await api.v1.shop.products.expectations.put(this.product._id, this.expectation);
                    alert("기대평이 등록되었습니다");
                    this.dialog = false
                    this.search();
                });
            }
        },

        async remove(expectation){
            if(confirm("기대평을 삭제하시겠습니까?")){
                await api.v1.shop.products.expectations.delete(this.product._id, expectation);
                alert("기대평이 삭제되었습니다");
                this.search();
            }
        }
    },
    computed: {
        logon(){ return !!this.$store.state.accessToken },
        payload(){ return this.$store.state.payload; }
    }
}
</script>

<style scoped>
@media (max-width:1024px){
}
@media (max-width:992px){
}
@media (max-width:600px){
    >>>.v-data-table--default table >tbody >tr >*:nth-child(1)
    >>>.v-data-table--default table >tbody >tr >*:nth-child(2)
    >>>.v-data-table--default table >tbody >tr >*:nth-child(3),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(4),
    >>>.v-data-table--default table >tbody >tr >*:nth-child(5){
        display: inline-block;
        border-bottom: none !important;
    }
}
@media (max-width:576px){
}
</style>